import "./CourseItem.scss";

import { images } from "../../constants";
import { useDispatch } from "react-redux";
import { setCourseToDeleting, setCourseToUpdating } from "../../actions/course";
import { openModal } from "../../actions/ui";

const CourseItem = ({ course }) => {
  const dispatch = useDispatch();

  const handleCourseEdit = (course) => {
    dispatch(setCourseToUpdating(course));
    dispatch(openModal());
  };
  const handleCourseDelete = (courseId) => {
    dispatch(setCourseToDeleting(courseId));
    dispatch(openModal());
  };
  return (
    <div className="course-item">
      <div className="course-item__heading">
        <div className="course-item__heading--img">
          <img src={images.IconCourseR} alt="bg-courses-img" />
        </div>

        <div className="course-item__heading--name">
          <h3 className="title-gray-bold-16 set-pointer">{course.name}</h3>

          <h2 className="title-gray-reg-12">
            Powered by {course.college.name}
          </h2>
        </div>
      </div>

      <div className="icons">
        <button
          className="icons__edit"
          onClick={() => handleCourseEdit(course)}
        >
          <img src={images.IconEdit} alt="icon to edit a course" />
        </button>
        <button
          className="icons__remove"
          onClick={() => handleCourseDelete(course._id)}
        >
          <img src={images.IconDelete} alt="icon to delete a course" />
        </button>
      </div>
    </div>
  );
};

export default CourseItem;
